import { ReactElement } from 'react';
import { Dropdown, TextInput } from '@components/common';
import { YesNoVal } from '@config/constant';
import { keyDownEvent } from '@helper/utils';
import { ICarpenterDetailsProps } from '.';

export const CarpenterDetails = ({ formik, isEditing, isCarpenterSaved }: ICarpenterDetailsProps): ReactElement => {
	const handleCarpenterChange = (field: string, value: string): void => {
		void formik.setFieldValue(field, value);

		if (value === 'No') {
			void formik.setFieldValue('boss_name', '');
			void formik.setFieldValue('boss_mobile', '');
		}
	};

	return (
		<>
			<li className="form-control d-col d-col-2">
				<Dropdown
					id="enable_carpenter_option"
					name="enable_carpenter_option"
					label="Is the user a Carpenter?"
					title={formik.values.enable_carpenter_option}
					onBlur={formik.handleBlur}
					options={YesNoVal}
					setFieldValue={handleCarpenterChange}
					error={
						formik.touched.enable_carpenter_option && formik.errors.enable_carpenter_option
							? formik.errors.enable_carpenter_option
							: null
					}
					disabled={isEditing || isCarpenterSaved}
					required
				/>
			</li>

			{formik.values.enable_carpenter_option === 'Yes' && (
				<>
					<li className="form-control d-col d-col-2">
						<TextInput
							id="boss_name"
							name="boss_name"
							type="text"
							label="Carpenter's Boss Name"
							value={formik.values.boss_name}
							onBlur={formik.handleBlur}
							onChange={(event) => void formik.setFieldValue('boss_name', event.target.value)}
							error={formik.touched.boss_name && formik.errors.boss_name ? formik.errors.boss_name : null}
							maxLength={50}
							disabled={isEditing}
							required
						/>
					</li>

					<li className="form-control d-col d-col-2">
						<TextInput
							id="boss_mobile"
							name="boss_mobile"
							type="text"
							label="Carpenter's Boss Mobile Number"
							value={formik.values.boss_mobile}
							onBlur={formik.handleBlur}
							setFieldValue={formik.setFieldValue}
							error={formik.touched.boss_mobile && formik.errors.boss_mobile ? formik.errors.boss_mobile : null}
							onKeyDown={keyDownEvent}
							maxLength={10}
							disabled={isEditing}
							required
						/>
					</li>
				</>
			)}
		</>
	);
};
